/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs */

const en_campaigns_mag7_spacex_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available only to persons in eligible jurisdictions outside the US.`)
};

const de_campaigns_mag7_spacex_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur für Personen in teilnahmeberechtigten Rechtsgebieten außerhalb der USA verfügbar.`)
};

const pt_br2_campaigns_mag7_spacex_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível apenas para pessoas em jurisdições elegíveis fora dos EUA.`)
};

const tr_campaigns_mag7_spacex_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca ABD dışındaki uygun yargı bölgelerinde bulunan kişiler kullanabilir.`)
};

const zh_cn2_campaigns_mag7_spacex_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅面向美国以外符合条件的司法辖区内的人士开放。`)
};

const zh_hk2_campaigns_mag7_spacex_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只限美國以外合資格司法管轄區的人士參加。`)
};

const ko_kr2_campaigns_mag7_spacex_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미국 외 자격을 갖춘 관할권에 거주하는 사람만 이용할 수 있습니다.`)
};

const ru_ru2_campaigns_mag7_spacex_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступно только лицам в допустимых юрисдикциях за пределами США.`)
};

const es_419_campaigns_mag7_spacex_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible solo para personas en jurisdicciones elegibles fuera de EE. UU.`)
};

/**
* | output |
* | --- |
* | "Available only to persons in eligible jurisdictions outside the US." |
*
* @param {Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_fine_print_eligibility = /** @type {((inputs?: Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Fine_Print_EligibilityInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_fine_print_eligibility(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_fine_print_eligibility(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_fine_print_eligibility(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_fine_print_eligibility(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_fine_print_eligibility(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_fine_print_eligibility(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_fine_print_eligibility(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_fine_print_eligibility(inputs)
	return es_419_campaigns_mag7_spacex_fine_print_eligibility(inputs)
});